import { navLog } from '@lib/utils/navLog';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RedirectForbidden: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navLog({
      event: 'redirect-forbidden-fired',
      pathname: window.location.pathname,
    });
    navigate('/forbidden');
  }, [navigate]);

  return null;
};

export default RedirectForbidden;
